import { FileEntity } from '../FileEntity';
import { ContentEntity } from './ContentEntity';

export class StaticPageEntity extends ContentEntity {
  iconImage_En: FileEntity;
  iconImage_Fr: FileEntity;

  constructor(entity?: StaticPageEntity) {
    super();
    if (entity) {
      Object.assign(this, { ...entity });
      this.effectiveDate = entity.effectiveDate;
      this.expiryDate = entity.expiryDate;
    } else {
      this.effectiveDate = new Date();
      this.expiryDate = new Date();
    }
  }
}
